import ChangeColumnTemplate from "./ChangeColumnTemplate.js";
import ClosingBalanceColumnTemplate from "./ClosingBalanceColumnTemplate.js";
import DeviationColumnTemplate from "./DeviationColumnTemplate.js";
import FormulaColumnTemplate from "./FormulaColumnTemplate.js";
import ModelFactory from "../../../ModelFactory.js";
import OpeningBalanceColumnTemplate from "./OpeningBalanceColumnTemplate.js";
import PercentageColumnTemplate from "./PercentageColumnTemplate.js";
import RollingPeriodColumnTemplate from "./RollingPeriodColumnTemplate.js";
import SeparatorColumnTemplate from "./SeparatorColumnTemplate.js";
import YearToDateColumnTemplate from "./YearToDateColumnTemplate.js";

/**
 * TODO: write documentation
 */
class ReportColumnTemplateFactory extends ModelFactory {
	allClasses() {
		return [
			ChangeColumnTemplate,
			ClosingBalanceColumnTemplate,
			DeviationColumnTemplate,
			FormulaColumnTemplate,
			OpeningBalanceColumnTemplate,
			PercentageColumnTemplate,
			RollingPeriodColumnTemplate,
			SeparatorColumnTemplate,
			YearToDateColumnTemplate,
		];
	}

	allItemClasses() {
		return this.allClasses().filter((klass) => klass.isVisible());
	}

	_getTypeFromJson(json) {
		return json.columnType;
	}
}

const reportColumnTemplateFactory = new ReportColumnTemplateFactory();

export default reportColumnTemplateFactory;
